/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.CostItemMappingResponseDto>
>;
export function request(
  params: API.basics.costItemMapping.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/costItemMapping/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
